import _ from 'lodash';
import { v4 } from 'uuid';

const applicationSchema = {
    people: [
        {
            roles: ['applicant'],
            first_name: '',
            last_name: '',
            title: '',
            date_of_birth: {
                dd: '',
                mm: '',
                yy: ''
            },
            email: '',
            emailUID: v4(),
            uid: v4(),
            phone: [
                {
                    uid: v4(),
                    number: '',
                    type: 'main'
                },
                {
                    uid: v4(),
                    number: '',
                    type: 'secondary'
                }
            ],
            addresses: [
                {
                    uid: v4(),
                    house_name: '',
                    house_number: '',
                    street_line_1: '',
                    street_line_2: '',
                    town: '',
                    equifax_token: '',
                    postcode: '',
                    country: 'uk'
                }
            ],
            privacy_policy_agreement_date: null,
            marketing_emails: false
        }
    ],
    company: {
        type: '',
        registered: {
            mm: '',
            yy: ''
        },
        annual_turnover: '',
        website: '',
        vat_registered_status: '',
        online_sales_percentage: ''
    },
    loan_request: {
        amount: '',
        purpose: '',
        urgency: '',
        detailed_reason: ''
    }
};

export const soleTraderSchema = _.merge({}, applicationSchema, {
    company: {
        annual_business_profit: '',
        industry: '',
        trading_as: ''
    },
    people: [
        {
            addresses: [
                {
                    monthly_expenses: '',
                    residential_status: ''
                }
            ],
            other_monthly_expenses: '',
            monthly_non_business_income: '',
            monthly_other_household_income: '',
            number_of_dependents: ''
        }
    ]
});

export const limitedCompanySchema = _.merge({}, applicationSchema, {
    company: {
        company_number: '',
        company_name: ''
    },
    people: [
        {
            addresses: [
                {
                    residential_status: ''
                }
            ]
        }
    ]
});

export default _.merge(
    {},
    applicationSchema,
    soleTraderSchema,
    limitedCompanySchema
);
